import { useQuery } from '@tanstack/react-query';
import { getUserFunctions } from 'api/userFunctions';
import { userFunctionsKeys } from 'api/queryKeys';
import { useMainCompanyQuery } from './useMainCompanyQuery';

export const useUserFunctionsQuery = () => {
  const { data: mainCompany } = useMainCompanyQuery();
  const companyId = mainCompany?.id ?? '';

  return useQuery({
    queryKey: userFunctionsKeys.list(companyId),
    queryFn: () => getUserFunctions().then((res) => res.data ?? []),
    enabled: !!companyId
  });
};
